const loginFooterStyles = {
    gridContainer: {
        flexDirection: 'column',
	},
	gridContainer1: {
		backgroundColor: '#EBEEF9',
		justifyContent: 'left',
		alignItems: 'center',
		padding: '8px 16px 8px 11px',
		gap: '10px',
        '& .MuiTypography-root': {
            color: '#111111',
            fontSize: '12px',
            fontWeight: 400,
            '@media (max-width: 900px)': {
                fontSize: '10px',
            },
        },
	},
	gridContainer2: {
        backgroundColor: '#EBFFEE',
		justifyContent: 'left',
		alignItems: 'center',
		padding: '8px 16px 8px 11px',
		gap: '10px',
		'& .MuiTypography-root': {
			color: '#009951',
			fontSize: '12px',
			fontWeight: 400,
            '@media (max-width: 900px)': {
                fontSize: '12px',
            },
		},
	},
	icon: {
		'& svg': {
			height: '24px',
			width: '24px',
			'@media (max-width: 900px)': {
			  height: '22px',
			  width: '22px',
			},
		  },
	}
}

export default loginFooterStyles